<template>
  <div class="loader-wrapper" v-if="$store.state.navigation.loader">
    <div class="loader">
      <div class="lds-dual-ring"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style lang="css">
.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f3f3f3;
  z-index: 9999;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.loader-wrapper .loader {
    display: inline-block;
}
.loader-wrapper .lds-dual-ring {
  display: inline-block;
  width: 64px;
  height: 64px;
}
.loader-wrapper .lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 1px;
  border-radius: 50%;
  border: 5px solid #fff;
  border-color: #434343 transparent #434343 transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loader/Loader.vue